export const SET_RELIC_VAULT_STATE = 'SET_RELIC_VAULT_STATE';
export const SET_RELIC_VAULT_HYDRATED = 'SET_RELIC_VAULT_HYDRATED';
export const ADD_OWNED_RELIC = 'ADD_OWNED_RELIC';
export const REMOVE_OWNED_RELIC = 'REMOVE_OWNED_RELIC';
export const ADD_OWNED_COMPANION = 'ADD_OWNED_COMPANION';
export const SET_EQUIPPED_COMPANION = 'SET_EQUIPPED_COMPANION';
export const SET_STORE_SLOTS = 'SET_STORE_SLOTS';
export const ADJUST_RELIC_VAULT_BALANCE = 'ADJUST_RELIC_VAULT_BALANCE';
export const RESET_RELIC_VAULT_BALANCE_ADJUSTMENT = 'RESET_RELIC_VAULT_BALANCE_ADJUSTMENT';
export const RESET_RELIC_VAULT = 'RESET_RELIC_VAULT';
